/** Portal locales that read right-to-left (see `angular.json` i18n locales). */
export function isRtlLocale(locale: string): boolean {
  return locale === 'ar' || locale === 'he';
}
